import { Injectable } from '@angular/core';
import { SimplifiedPaginator } from '@app/classes/simplified-paginator';
import { PadAgreementLog } from '@app/models/payroll/pad-agreement-log.model';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService, NotifyService } from '@app/services';
import { CompanyMetaService } from '@company/services/company-meta.service';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { AcknowledgedAtColumn, EmailColumn, IpAddressColumn, NameColumn } from './columns';

@Injectable()
export class PadAgreementLogsTable extends Table<PadAgreementLog> {
    private showName = false;

    constructor(
        protected auth: AuthService,
        private companyMetaService: CompanyMetaService,
        private notifyService: NotifyService,
        private translateService: TranslateService
    ) {
        super(auth);
    }

    initialize(showName: boolean): void {
        this.showName = showName;
        this.boot();
    }

    setDataSource(): void {
        this.paginator = new SimplifiedPaginator<PadAgreementLog>(
            this.companyMetaService.getPadAgreementLogs$().pipe(
                tap({
                    error: () => this.notifyService.error('payroll.setup.padAgreementLogs.error'),
                })
            )
        );
    }

    setColumns(): void {
        if (this.showName) {
            this.addColumns(new NameColumn());
        }
        const locale = this.translateService.currentLang.replace('_', '-');
        this.addColumns(new EmailColumn(), new AcknowledgedAtColumn(locale), new IpAddressColumn());
    }
}
